import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from "vuex";
import { ConflictError, BadRequestError } from "~/abstractions/errors";

export default {
    props: {
        team: Object,
        index: Number,
        completeFields: Boolean,
        typeOfTable: Object,
        withSearchBox: false,
        withCompleteTableFields: true,
        additionButtonVisibility: true
    },
    data: function data() {
        var teamStatus = this.team.active;
        return {
            headers: [{ text: "NOMBRE", value: "name" }, { text: "USUARIO", value: "user" }, { text: "NRO. DOC", value: "documentNumber" }, { text: "CORREO", value: "email" }, { text: "CANAL", value: "channel" }, { text: "SUB CANAL", value: "subchannel" }, { text: "ESTADO", value: "state" }],
            searchTerm: "",
            inSearchProcess: false,
            filteredItems: [],
            editSupervisor: false,
            additionButton: "",
            showHeadTable: true,
            typeItemsTable: "",
            showSupervisor: false,
            showTable: false,
            sellersTable: false,
            idBoss: "",
            idTeam: "",
            isActive: "",
            isActiveSwitch: false
        };
    },

    methods: {
        search: function search(term) {
            var _this = this;

            this.inSearchProcess = true;
            this.filteredItems = this.channelsItems.filter(function (item) {
                var stringContentTerm = _this.stringContainsTerm(item.name, term) || _this.stringContainsTerm(item.documentNumber, term) || _this.stringContainsTerm(item.channel, term);
                if (stringContentTerm) return item;
            });
        },
        stringContainsTerm: function stringContainsTerm(string, term) {
            if (string === null || undefined && term === null || undefined) return;
            var stringLowerCase = string.toLowerCase();
            var termToSearch = term.toLowerCase();
            return stringLowerCase.indexOf(termToSearch) > -1 ? true : false;
        },
        transformDataToDownload: function transformDataToDownload(data) {
            return {
                // Id: data.value,
                Usuario: data.user,
                "Nombre(s)": data.firstName,
                Apellidos: data.lastName,
                // Nombre: data.name,
                "Tipo de Doc.": data.documentType,
                "Nº de Doc.": data.documentNumber,
                Correo: data.email,
                Telefono: data.phone,
                Rol: data.role,
                Canal: data.channel,
                "Sub Canal": data.subchannel,
                "Grupo Canal": data.groupChannelName,
                Equipo: data.team,
                Jefe: data.boss,
                Supervisor: data.supervisor ? "Si" : "No",
                Activo: data.active ? "Si" : "No"
            };
        },
        downloadData: function downloadData() {
            var _this2 = this;

            var emptyChannelItems = {
                // Id: "",
                Usuario: "",
                "Nombre(s)": "",
                Apellidos: "",
                "Tipo de Doc.": "",
                "Nº de Doc.": "",
                Correo: "",
                Telefono: "",
                Rol: "",
                Canal: "",
                "Sub Canal": "",
                "Grupo Canal": "",
                Equipo: "",
                Jefe: "",
                Supervisor: "",
                Activo: ""
            };
            var newChannelItems = this.channelsItems.map(function (item) {
                return _this2.transformDataToDownload(item);
            });
            var dataFileName = String(this.$store.state.team.dataTeam.Name || Math.floor(new Date() / 1000));
            var dataToParse = _JSON$stringify({
                response: newChannelItems.length >= 1 ? newChannelItems : emptyChannelItems,
                filename: "Reporte vendedores - " + dataFileName.toLowerCase()
            });
            this.$store.dispatch("dashboard/table/getTableBossesChannelById", dataToParse);
        },
        slideToggle: function slideToggle(val) {
            this.showTable = !this.showTable;
            this.idBoss = val.value;
            if (this.typeOfTable.typeOfTable == "DetailTeam") {
                this.additionButton = "Nuevo Vendedor";
                this.showSupervisor = true;
            }

            if (this.showTable == true) {
                this.$emit("showChannels");
            }
        },
        addNewItem: function addNewItem(val) {
            this.$emit("addNewItem");
        },
        editItem: function editItem() {
            this.$emit("editThisChannel");
        },
        toDetailTable: function toDetailTable(val) {
            this.idTeam = val.item.value;
            this.showTable = false;
            if (this.typeOfTable.typeOfTable == "Channels") {
                this.$emit("toDetailTable", { val: val, type: "DetailTeam" });
                this.$emit("toTeamsTable", { val: val, type: "DetailTeam" });
                this.typeItemsTable = "Colaboradores";
            } else if (this.typeOfTable.typeOfTable == "DetailTeam") {
                this.$emit("editSellerTable", val);
            } else if (this.typeOfTable.typeOfTable == "Teams") {
                this.$emit("toDetailTable", { val: val, type: "DetailSellers" });
            } else if (this.$isSupervisor()) {
                this.$emit("editSellerTable", val);
            } else if (this.typeOfTable.typeOfTable == "DetailSellers") {
                this.$emit("editSellerTable", val);
            }
        },
        status: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(val) {
                var conditional, data;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                conditional = this.idTeamforEdit || this.idBoss;
                                data = {
                                    idBoss: conditional,
                                    val: val
                                };
                                _context.prev = 2;

                                if (!(this.typeOfTable.typeOfTable == "Channels")) {
                                    _context.next = 9;
                                    break;
                                }

                                this.$store.commit("boss/updateStatusChannel", data);
                                _context.next = 7;
                                return this.$store.dispatch("channel/editChannelManagement", {
                                    idChannel: val.id,
                                    idBoss: this.index,
                                    isActive: val.active
                                });

                            case 7:
                                _context.next = 25;
                                break;

                            case 9:
                                if (!(this.typeOfTable.typeOfTable == "Teams")) {
                                    _context.next = 15;
                                    break;
                                }

                                this.$store.commit("channel/updateStatusTeam", data);
                                _context.next = 13;
                                return this.$store.dispatch("team/editTeamManagement", {
                                    idTeam: val.value,
                                    isActive: val.active
                                });

                            case 13:
                                _context.next = 25;
                                break;

                            case 15:
                                if (!(this.typeOfTable.typeOfTable == "DetailTeam")) {
                                    _context.next = 21;
                                    break;
                                }

                                this.$store.commit("channel/updateStatusSeller", data);
                                _context.next = 19;
                                return this.$store.dispatch("team/editSellerManagement", {
                                    idSeller: val.value,
                                    isActive: val.status
                                });

                            case 19:
                                _context.next = 25;
                                break;

                            case 21:
                                if (!(this.typeOfTable.typeOfTable == "DetailSellers" || this.typeOfTable.typeOfTable == "")) {
                                    _context.next = 25;
                                    break;
                                }

                                this.$store.commit("team/updateStatusSeller", data);
                                _context.next = 25;
                                return this.$store.dispatch("team/editSellerManagement", {
                                    idSeller: val.value,
                                    isActive: val.active
                                });

                            case 25:
                                _context.next = 30;
                                break;

                            case 27:
                                _context.prev = 27;
                                _context.t0 = _context["catch"](2);

                                if (_context.t0 instanceof ConflictError) {
                                    this.$swal("No se pudieron guardar tus cambios", _context.t0.message, "warning");
                                    this.$emit("showChannels");
                                } else if (_context.t0 instanceof BadRequestError) {
                                    this.$swal("Error", _JSON$stringify(_context.t0.data.constraints[0].constraints.isEmail), "warning");
                                } else {
                                    this.$controlMessage(_context.t0);
                                }

                            case 30:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[2, 27]]);
            }));

            function status(_x) {
                return _ref.apply(this, arguments);
            }

            return status;
        }()
    },
    mounted: function mounted() {
        if (this.$isSupervisor()) {
            this.showTable = true, this.showSupervisor = true, this.editSupervisor = false;
        } else if (this.$isBoss()) {
            this.additionButton = "Nuevo Equipo";
            this.typeItemsTable = "Equipos";
        } else if (this.$isAdmin() || this.$isAdminCollaborator()) {
            this.additionButton = "Nuevo Canal";
            this.typeItemsTable = "Canales";
        }

        if (this.typeOfTable.typeOfTable == "Teams") {
            this.typeItemsTable = "Equipos";
        } else if (this.typeOfTable.typeOfTable == "Channels") {
            this.typeItemsTable = "Canales";
        } else if (this.typeOfTable.typeOfTable == "DetailTeam") {
            this.typeItemsTable = "Colaboradores";
            if (this.$isBoss()) {
                this.showTable = true;
                this.showHeadTable = false;
                this.showSupervisor = true;
            }
        }
        if (this.$route.query.channelStatus) {
            this.isActiveSwitch = this.typeOfTable.typeOfTable == "DetailTeam" ? this.$route.query.channelStatus : !this.$route.query.channelStatus;
        } else if (this.$route.query.bossStatus) {
            this.isActiveSwitch = !this.$route.query.bossStatus;
        } else if (this.$isSupervisor()) {
            this.isActiveSwitch = true;
        }
    },

    watch: {
        searchTerm: function searchTerm(val) {
            if (val.length === 0) {
                this.inSearchProcess = false;
                this.filteredItems = [];
            }
        },
        typeOfTable: function typeOfTable(val) {
            if (val.typeOfTable == "DetailSellers") {
                this.showTable = true;
                this.showSupervisor = true;
                this.editSupervisor = true;
                this.sellersTable = true;
                this.showHeadTable = false;
                if (this.$isBoss()) {
                    this.editSupervisor = false;
                }
            } else if (val.typeOfTable == "DetailTeam") {
                if (this.$isBoss(val)) {
                    this.showHeadTable = false;
                }
            }
        }
    },
    computed: _extends({}, mapState({
        idTeamforEdit: function idTeamforEdit(state) {
            return state.channel.idTeam;
        },
        showTableData: function showTableData(state) {
            return state.collaborators.teams.showTable;
        }
    }), {
        isSupervisorCanActivate: function isSupervisorCanActivate() {
            return this.$isSupervisor ? false : true;
        },
        tableData: function tableData() {
            if (this.inSearchProcess) return this.filteredItems;
            return this.channelsItems;
        },
        channelsItems: function channelsItems() {
            if (this.$isSupervisor()) {
                var supervisors = this.team.items.filter(function (item) {
                    item.status = item.active;
                    if (item.supervisor === true) return item;
                });
                var others = this.team.items.filter(function (item) {
                    item.status = item.active;
                    if (item.supervisor === false) return item;
                });
                return supervisors.concat(others);
            } else {
                return this.team.items.map(function (item) {
                    item.status = item.active;
                    return item;
                });
            }
        },
        changeData: function changeData() {
            if (this.typeOfTable.typeOfTable == "Teams") {
                this.typeItemsTable = "Equipos";
            }
        },
        tableIsLoading: function tableIsLoading() {
            if (this.team.channels <= 0) return false;
            if (this.channelsItems && this.channelsItems.length > 0) return false;
            return true;
        }
    })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/slide-item.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/slide-item.vue
// module chunks = 4 6 7 8 9